export default "__VITE_ASSET__B6yBva2f__"